<template>
	<div class="">
		<login-after-head-center></login-after-head-center>
		<div id="member" class="container home-container flex">
			<side-nav></side-nav>
			<div id="coupon" class="award-page">
				<div class="home-allTitle award-title-cg" >
				    <span>优惠券</span>
				</div>
				<div class="award-nav award-nav-cg fc">
					<span class="text hand" :class="{'goods-active':tabIndex==0}" @click="tabClick(0)">
						领券中心
					</span>
					<span class="line"></span>
					<span class="text hand" :class="{'goods-active':tabIndex==1}" @click="tabClick(1)">
						可使用
					</span>
					<span class="line"></span>
					<span class="text hand" :class="{'goods-active':tabIndex==2}" @click="tabClick(2)">
						已使用
					</span>
					<span class="line"></span>
					<span class="text hand" :class="{'goods-active':tabIndex==3}" @click="tabClick(3)">
						已过期
					</span>
				</div>
        <div v-if="couponList.length==0 && couponLoading==false">
          <div class="coupon-none">
            <div class="award-left"></div>
            <span>暂无优惠券</span>
          </div>
        </div>
				<div v-else v-loading="couponLoading">
					<div class="evaluate-list ">
						<div class="list-title list-titleColor">
							<span class="width170">券名称</span>
							<span class="width518" style="text-align: left;">券描述</span>
							<span class="width250" v-if="tabIndex==0">领取时间</span>
              <span class="width250" v-else>过期时间</span>
              <span class="width120">操作</span>
						</div>
						<div class="list-item flex"  v-for="(item,index) in couponList" :key="index">
							<div class="width170">{{item.promotionName}}</div>
							<div class="width518" >
                {{item.promotionDesc}}

							</div>
							<div class="width250 fcc"  v-if="tabIndex==0">{{parseTimeY(item.startTime)}}-{{parseTimeY(item.endTime)}}</div>
              <div class="width250 fcc" v-else>{{parseTimeX(item.expireTime)}}</div>
              <div class="width120 fcc" v-if="tabIndex==0">
                <a href="" class="btn-"  v-if="item.isUse">
                  已领取
                </a>
                <a class="btn-" style="cursor:pointer;"   v-else  @click.stop="receiveCoupon(item.id,index)">
                  领取
                </a>
              </div>
              <div class="width120 fcc" v-else>
                <a href="/" class="btn-" style="cursor:pointer;"   v-if="item.status==0">
                  去使用
                </a>
                <a class="btn-get fcc" v-if="item.status==1">
                  已使用
                </a>
                <a class="btn-get fcc" v-if="item.status==2" >
                  已过期
                </a>
              </div>
						</div>
					</div>
				</div>

        <el-pagination
            :page-size.sync="page.size"
            :total="page.total"
            :current-page.sync="page.page"
            style="margin-top: 8px;"
            layout="total, prev, pager, next, sizes"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
			</div>
		</div>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
	</div>
</template>

<script>
import {
  mapGetters
} from "vuex";
import {parseTimeX, parseTimeY} from '@/utils'
import {getCoupons,receiveCoupon,getMyCouponList} from "@/api/ec/coupons.js";

export default {
  computed: mapGetters(["userInfo"]),
  data() {
    return {
      couponLoading:true,
      fixed: false,
      loaded: false,
      loading: false,
      couponList: [],
      channel:null,
      tabIndex:0,
      page:{
        page:1,
        size:10,
        total:0
      }
    };
  },
  mounted() {
    this.getCouponsList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.couponList=[]
      if(this.tabIndex==0) {
        this.getCouponsList();
      }else {
        this.getMyCouponsList();
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.couponList=[]
      if(this.tabIndex==0) {
        this.getCouponsList();
      }else {
        this.getMyCouponsList();
      }
    },
    parseTimeY,
    parseTimeX,
    tabClick(index){
      if(this.tabIndex == index) return;
      this.tabIndex = index
      this.chooseTab();
    },
    //点击tab重置参数  获取数据
    chooseTab() {
      this.couponList = [];
      this.page.page = 1;
      this.loading = false;
      this.loaded = false;
      if(this.tabIndex==0) {
        this.getCouponsList();
      }else {
        this.getMyCouponsList();
      }
    },
    getMyCouponsList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.couponLoading = true;
      var data = {
        page:this.page.page,
        limit:this.page.size,
        status: this.tabIndex-1
      };
      console.log(data);
      // uni.showLoading({
      //   title: "Loading...",
      // });
      getMyCouponList(data).then(res => {
        this.loading = false;
        this.loaded = res.data.content.length < this.page.limit;
        this.couponList.push.apply(this.couponList, res.data.content);
        this.page.total = res.data.totalElements;
        //uni.hideLoading();
      }).catch(err => {
        // uni.hideLoading();
        // uni.showToast({
        //   title: err.msg,
        //   icon: "none",
        //   duration: 2000,
        // });
      }).finally(() => {

        this.couponLoading = false;
      })
    },
    //获取优惠券列表
    getCouponsList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.couponLoading = true;
      var data = {
        page:this.page.page,
        limit:this.page.size,
      };
      // uni.showLoading({
      //   title: "Loading...",
      // });
      getCoupons(data).then(res => {
        this.loading = false;
        this.loaded = res.data.length < this.page.limit;
        this.couponList.push.apply(this.couponList, res.data);
        this.page.total = res.total;
        //uni.hideLoading();
      }).catch(err => {
        //uni.hideLoading();
        // uni.showToast({
        //   title: err.msg,
        //   icon: "none",
        //   duration: 2000,
        // });
      }).finally(() => {
        this.couponLoading = false;
      })

    },
    //立即领取
    receiveCoupon(id,index) {
      let that=this;
      receiveCoupon(id).then(res => {
        // uni.showToast({
        //   title: "领取成功"
        // })
        that.$message({
          message: '领取成功',
          type: 'success'
        });
        //领取优惠券后 更改优惠券领取状态
        // that.couponList[index].isUse = true;
        this.chooseTab()
      }).catch(err => {
        that.$message({
          message: err.msg,
          type: 'error'
        });
      })
    }
  }
}
</script>

<style scoped lang="less">
	.award-page{
		min-height: 500px;
	}
	.list-item{
		padding: 10px 20px;
		font-size: 12px;
	}
	.list-item + .list-item{
		border-top: 1px solid #F8F8F8;
	}
</style>
